<template>
  <div class="instant-result__section">
    <h3 v-if="showHeader" class="instant-result__header">
      {{ tStatic('superUserSearchResults') }}
    </h3>

    <ul class="instant-result__list">
      <li v-for="(item, index) in items" :key="`superuser-${item.code}-${index}`" class="instant-result__item">
        <component
          :is="businessCentralItemUrl(item) ? 'a' : 'div'"
          :href="businessCentralItemUrl(item)"
          :target="businessCentralItemUrl(item) ? '_blank' : null"
          :rel="businessCentralItemUrl(item) ? 'noopener noreferrer' : null"
          :title="businessCentralItemUrl(item) ? tStatic('superUserBCArticleLinkLabel') : null"
          class="instant-result__link instant-superuser-result__link"
          :class="{ 'instant-result__is-active': activeSearchItem === item }">
          <oie-base-image
            :images="item.imageUrl ? getAssetPath(`${item.imageUrl}?preset=ProductSmall&watermark=OIEWatermarkSmall`) : getAssetPath('/globalassets/missing404/404.png?preset=ProductThumb')"
            :alt-text="item.name"
            image-width="3.75rem"
            image-height="3.75rem"
            class="instans-result__product-image"></oie-base-image>

          <!-- Bound as text, not v-html: these come straight from BC via AddInternalErpSearchResults
               with no encoding, and the reference number is customer-editable. -->
          <div class="instant-result__name-container instant-superuser-result__text">
            <div class="instant-superuser-result__name">
              {{ item.name }}
            </div>
            <span v-if="item.company" class="instant-result__reference-number">{{ item.company }}</span>
            <span v-if="item.referenceNumber" class="instant-result__reference-number">{{ tStatic('referenceNumberLabel') }} {{ item.referenceNumber }}</span>
          </div>

          <oie-base-icon
            v-if="businessCentralItemUrl(item)"
            icon="launch"
            size="s"
            class="instant-superuser-result__icon"></oie-base-icon>
        </component>
      </li>
    </ul>
  </div>
</template>

<script>
import { businessCentralItemUrl } from '@/core/search-service'

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    // The search page shows these under a tab that already carries the label.
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    activeSearchItem() {
      return this.$store.getters['ui/activeSearchItem']
    }
  },
  methods: {
    businessCentralItemUrl(item) {
      return businessCentralItemUrl(this.tStatic('superUserBCArticleLinkTemplate'), item.itemId)
    }
  }
}
</script>

<style lang="scss">
.instant-superuser-result__text {
  flex-grow: 1;
}

.instant-superuser-result__name {
  color: color(text-gray);
}

.instant-superuser-result__icon {
  flex-shrink: 0;
  margin-left: measure(quarter);
  color: color(text-blue);
}

div.instant-superuser-result__link:hover {
  background-color: transparent;
  cursor: default;
}
</style>
